import { useMutation } from '@tanstack/react-query';

import { LitigationFormData } from '../types';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig, queryClient } from '@/lib/react-query';

const updateLitigation =
  (makeRequest: any, shipmentId: string) =>
  async ({
    litigationData,
    litigationId,
  }: {
    litigationData: LitigationFormData;
    litigationId: string;
  }): Promise<void> => {
    const { data, error } = await makeRequest({
      path: `/shipments/${shipmentId}/litigations/${litigationId}`,
      method: 'put',
      body: litigationData,
    });

    if (!data || error) {
      throw new Error(error);
    }
  };

type UseUpdateLitigation = {
  config?: MutationConfig<ReturnType<typeof updateLitigation>>;
  shipmentId: string;
};

export const useUpdateLitigation = ({
  config,
  shipmentId,
}: UseUpdateLitigation) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useMutation({
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['litigation', shipmentId],
      });
    },
    ...config,
    mutationFn: updateLitigation(makeRequest, shipmentId),
  });
};
